import React from 'react';
import PropTypes from 'prop-types';

import icons from './icons';

import { RightArrow } from './RightArrow';

const Icon = ({ icon, ...rest }) => {
  if (icon === 'RightArrow') {
    return <RightArrow />;
  }

  const Icon = icons[icon];
  return Icon ? <Icon {...rest} /> : null;
};

Icon.propTypes = {
  icon: PropTypes.string.isRequired
};

export default Icon;
